export default __webpack_public_path__ + "static/media/ovalsSameSize.6c07ad62.png";